import { FC, memo, useMemo } from 'react'

import { ItemType } from '@inno-sdks/files'
import { toast } from '@inno-ui/toast'
import { useGetFileItem } from 'modules/desktop/modules/files-integration/api'
import { useTranslation } from 'react-i18next'

import { FileModal, FolderModal, ShortcutModal } from './Modals'
import { useItemModal } from './hooks/useItemModal'

const modalsMapping: Record<ItemType, FC> = {
  [ItemType.File]: FileModal,
  [ItemType.Folder]: FolderModal,
  [ItemType.Shortcut]: ShortcutModal
}

export const FilePreviewModal = memo(() => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop'
  })
  const { itemId, close } = useItemModal()
  const { data: item, error } = useGetFileItem(itemId)

  const Modal = useMemo(
    () => (item?.type ? modalsMapping[item.type] : FileModal),
    [item?.type]
  )

  if (error) {
    toast.error({
      title: t('item_not_found.title'),
      subTitle: t('item_not_found.subtitle')
    })

    close({ force: true })

    return null
  }

  return <Modal />
})
